import { effectiveAppRole } from '../utils/roles.js';

/**
 * Textos del Guía ALINEA: claros, cálidos, sin jerga.
 */
export function firstNameOf(user) {
    const raw = String(user?.nombre_completo || user?.full_name || user?.name || '').trim();
    return raw.split(/\s+/)[0] || 'hola';
}

export function getAlineaGuide(user, pathname, extras = {}) {
    const role = effectiveAppRole(user?.rol ?? user?.role) || 'worker';
    const path = String(pathname || '/');
    const name = firstNameOf(user);
    const hasStart = extras.hasStartCheckin === true;
    const hasEnd = extras.hasEndCheckin === true;
    const feeling = extras.feeling || null;

    if (role === 'worker') {
        if (path.startsWith('/messages')) {
            return {
                phase: 'Mensaje del día',
                hello: `${name}, aquí va un empujón suave para el turno.`,
                tip: 'Léelo si te sirve. No es una orden. Si el día está pesado, vuelve a Jornada o pide una pausa en EPA.',
                next: { to: '/', label: 'Ir a Jornada' },
            };
        }
        if (path.startsWith('/epa') || path.startsWith('/apoyos')) {
            return {
                phase: 'Pausa y perfil',
                hello: `${name}, esto es para regularte, no para evaluarte.`,
                tip: 'Si te sientes indispuesto, márcalo con claridad. Así tu líder puede cuidar la seguridad del puesto.',
                next: { to: '/', label: 'Volver a Jornada' },
            };
        }
        if (hasStart && !hasEnd) {
            return {
                phase: 'Turno en curso',
                hello: `${name}, ya marcaste llegada${feeling === 'mal' ? '. Hoy conviene ir suave' : ''}.`,
                tip: 'Si el cuerpo pide parar, usa EPA. Al salir, cierra el día en Jornada cuando puedas.',
                next: { to: '/messages', label: 'Ver mensaje del día' },
            };
        }
        if (hasEnd) {
            return {
                phase: 'Cierre',
                hello: `${name}, gracias por registrar el día.`,
                tip: 'Descansa. Mañana otro toque de llegada basta para seguir acompañado.',
                next: { to: '/messages', label: 'Ver mensaje' },
            };
        }
        return {
            phase: 'Llegada',
            hello: `Buen día, ${name}.`,
            tip: 'Toma 20 segundos: marca cómo llegas. Un registro honesto ayuda más que uno “perfecto”. Si estás indispuesto, dilo.',
            next: { to: '/', label: 'Marcar llegada' },
        };
    }

    if (role === 'supervisor') {
        if (path.startsWith('/alerts')) {
            return {
                phase: 'Semáforo',
                hello: `${name}, una alerta es para conversar, no para sancionar.`,
                tip: 'Lee “qué puedes hacer ahora”, habla en privado y deja una nota corta. Si quieres, copia el tip a WhatsApp.',
                next: { to: '/', label: 'Ver equipo' },
            };
        }
        if (path.startsWith('/apoyos')) {
            return {
                phase: 'Apoyos',
                hello: `${name}, aquí están las herramientas para acompañar.`,
                tip: 'Escucha primero. Ofrece algo concreto: claridad, apoyo o una pausa.',
                next: { to: '/alerts', label: 'Ver alertas' },
            };
        }
        return {
            phase: 'Tu equipo',
            hello: `${name}, mira cómo llega la manada hoy.`,
            tip: 'Acércate a quien está cargado. Pregunta: “¿Cómo vas? ¿Qué necesitas?” Dos minutos bastan.',
            next: { to: '/alerts', label: 'Abrir alertas' },
        };
    }

    if (path.startsWith('/messages')) {
        return {
            phase: 'Mensajes',
            hello: `${name}, este es el canal de recordatorios y guías.`,
            tip: 'Completa el banco si faltan textos. El botón WA copia el mismo mensaje para pegar en WhatsApp (aún no se envía solo).',
            next: { to: '/alerts', label: 'Ver alertas' },
        };
    }
    if (path.startsWith('/alerts')) {
        return {
            phase: 'Alertas',
            hello: `${name}, el semáforo guía el acompañamiento.`,
            tip: 'Cada señal trae pasos claros. Úsalos con las personas, no como lista de culpa.',
            next: { to: '/epa', label: 'Abrir EPA' },
        };
    }
    if (path.startsWith('/epa')) {
        return {
            phase: 'EPA',
            hello: `${name}, EPA es Escucha, Procesa y Ajusta.`,
            tip: 'Indispuesto no es diagnóstico: es “hoy no estoy para la carga normal”. Cuida seguridad y deriva si toca.',
            next: { to: '/alerts', label: 'Ver alertas' },
        };
    }
    if (path.startsWith('/calculator')) {
        return {
            phase: 'CID',
            hello: `${name}, aquí se habla el idioma de la empresa.`,
            tip: 'La rotación, para la persona, suele ser una salida. El CID muestra el costo de no acompañar a tiempo.',
            next: { to: '/alerts', label: 'Volver a señales' },
        };
    }

    return {
        phase: 'Acompañamiento',
        hello: `${name}, estoy aquí para señalar el siguiente paso.`,
        tip: 'Jornada y mensajes para la persona. Alertas y EPA para liderar. CID para dirección. Nada de esto sustituye una conversación.',
        next: { to: '/messages', label: 'Abrir mensajes' },
    };
}
